import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';

/**
 * Collapsible wrapper for an entire stat section (overview + heatmap)
 */
const StatSection = ({ title, children, collapsedContent, defaultExpanded = true }) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div className="mb-4 bg-white rounded-lg shadow">
      {/* Header with toggle and collapsed content inline */}
      <div 
        className={`p-3 flex items-center gap-4 cursor-pointer hover:bg-gray-50 ${isExpanded ? 'border-b border-gray-200' : ''}`}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <h2 className="text-lg font-bold text-gray-900 whitespace-nowrap">{title}</h2>
        
        {/* Collapsed Summary - Inline with header */}
        {!isExpanded && collapsedContent && (
          <div className="flex-1 min-w-0">
            {collapsedContent}
          </div>
        )}
        
        {/* Chevron */}
        <div className="ml-auto">
          {isExpanded ? (
            <ChevronUpIcon className="h-5 w-5 text-gray-600" />
          ) : (
            <ChevronDownIcon className="h-5 w-5 text-gray-600" />
          )}
        </div>
      </div>

      {/* Full Content */}
      {isExpanded && (
        <div className="p-4">
          {children}
        </div>
      )}
    </div>
  );
};

export default StatSection;

